import React from "react";

import { P } from "../../../styles";
import Menu from "./menu";
import styled from "@emotion/styled";
import { Container, Grid } from "@mui/material";

const Background = styled.div`
  background: url("/images/mainbg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  align-items: center;
  @media screen and (max-width: 899px) {
    padding: 100px 0 0 0;
  }
`;
const ReadMore = styled.a`
  text-decoration: none;
  background-color: #fff;
  cursor: pointer;
  background: linear-gradient(to top, #62B14C, #049A48);
  border-radius: 11px;
  padding: 7px 30px 7px 30px;
  font-family: "Poppins-Regular";
  font-size: 14px;
  margin-right: 3px;
  box-shadow: ${(props) =>
    props.bs ? props.bs : "inset 0px 2px 5px 0px #62B14C"};
  &:hover {
    opacity: 0.8;
  }
`;
const View = styled.a`
  text-decoration: none;
  background-color: #fff;
  cursor: pointer;
  background: transparent;
  border: 1px solid #fff;
  border-radius: 11px;
  padding: 7px 30px 7px 30px;
  font-family: "Poppins-Regular";
  font-size: 14px;
  margin-right: 3px;
  &:hover {
    opacity: 0.8;
  }
`;
const Title = styled.span`
  color: #fccb00;
  font-weight: 600;
  font-size: 18px;
`;
const ImgIntro = styled(Grid)`
  min-Height:calc(100vh - 140px);
  @media (max-width: 900px){
    min-Height:calc(100vh - 280px);
  }
`
const Intro = styled(Grid)`
  justify-content: center;

  padding: 50px 0 0 0;
  display: flex;
  align-items: ${(props) => (props.alignitem ? props.alignitem : "end")};
  @media screen and (max-width: 899px) {
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
`;
const Text = styled(Grid)`
  padding: 0px 0 0 0;
  display: flex;
  align-items: end;
  justify-content: center;
  @media screen and (max-width: 899px) {
    padding: ${(props) => (props.p599 ? props.p599 : "")};
  }
`;
const VideoBK = styled.video`
  /* width: 100%;
  height: auto;
  display: block; */
  object-fit: cover;
  width: 100%;
  height: 100vh;
  position: absolute;
  z-index: -1;
`;
const HomeImage = styled.img`
  width: 100%;
  height: auto;
  // max-width:500px;
  @media (max-width:2000px){
    max-width: 400px;
  }
  @media (max-width:1599px){
    max-width: 350px;
  }
  @media (max-width:1299px){
    max-width: 300px;
  }
  
`;
const Desc = styled.p`
  font-size:13px;
  @media (max-width: 1400px) and (min-width: 1024px){
    margin: 20px 0 10px 0;
    width:700px;
  }
  @media (min-width: 1401px){
    margin: 40px 0 10px 0;
    width:700px;
  }
`
const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  justify-content: flex-end;
  @media (max-width: 767px){
    height: calc(100vh + 40px);
  }
  @media (max-width: 1300px) and (min-width: 1024px){
    height: calc(100vh - 35px);
  }
  @media (min-width: 1301px){
    height: calc(100vh - 17px);
  }
`

const Index = () => {
  const Span = styled.span``;
  return (
    <div>
      <VideoBK autoPlay loop muted>
        <source src="/images/jadevideo.mp4" type="video/mp4" />
      </VideoBK>
      <Menu />
      {/* <Background> */}
      <Container maxWidth="xl">
            <ContentWrapper>
              <Desc fs="12px" style={{ textAlign: "center" }}>
              Throughout history, tales of dragons have captivated the imaginations of the Chinese people.
              Like other legendary creatures, dragons have been interpreted differently across various cultures, 
              especially within the Chinese Culture.
              </Desc>
              <div>
                <ReadMore>Buy Now</ReadMore>
                <View>View Chart</View>
              </div>
            </ContentWrapper>
      </Container>
      {/* </Background> */}
    </div>
  );
};

export default Index;
